import { render } from "./Nota.vue?vue&type=template&id=72f0a6c0&scoped=true"
import script from "./Nota.vue?vue&type=script&lang=ts"
export * from "./Nota.vue?vue&type=script&lang=ts"

import "./Nota.vue?vue&type=style&index=0&id=72f0a6c0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-72f0a6c0"

export default script